module.exports = __webpack_public_path__ + "static/media/delay_icon-dark.867575dd.svg";